export enum CurrencyEnum {
  EUR = 'EUR',
  USD = 'USD',
  GBP = 'GBP',
  CAD = 'CAD',
  CHF = 'CHF',
  JPY = 'JPY',
}

export enum CurrencySymbolEnum {
  EURO = '€',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  EUR = '€',
  USD = '$',
  GBP = '£',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  CAD = '$',
  CHF = '₣',
  JPY = '¥',
}

export enum CryptocurrenciesEnum {
  USDT = 'USDT'
}

export enum CryptocurrenciesNetworkCodesEnum {
  SOLANA = 'SOLANA'
}

export enum NumberSignEnum {
  Positive = '+',
  Negative = '-'
}

